import gql from 'graphql-tag';

export const SURPLUSES_BUFFERS_QUERY = gql`
  query SurplusesHome(
    $timeAfter: Int!
  ) {
    surpluses(
      timeAfter: $timeAfter
    ) {
      edges {
        node {
          plantings {
            id
            planting_time
            trays_rounded
            yield_per_tray_ounces
            planted_at
            crop {
              id
              crop_name
              yield_unit
              max_hold_time
            }
          }
        }
      }
    }
  }
`;
